import axios from "../../../../../../api/axios"
export const initialState = {
    loading:true,
    orders:null,
    drivers:null,
    customers:null,
    freights:null
}
export const reducer = (state,actions)=>{
    const {payload,type} = actions;
    switch (type) {
        case 'LOADING':
            return {...state,loading:payload};
        case 'LOAD_STATISTICS':
            return {...state,...payload,loading:false};
        default:
            return {...state}
    }
}
export const actions = {
    loadStatistics:async()=>{
        try {
            const {data} = await axios.get(`/api/v1/admin/report/statistics`)
            return data;
        } catch (error) {
            throw error;
        }
    }
}